import React, { Component } from 'react'
import { DialogButton } from '../Modal/Modal'
import { Spinner } from '../Loaders/Loaders'
import ReactMarkdown from 'components/Markdown/Markdown'
import { REQUEST_RECORD_ACCESS, GET_USER_HAS_ALREADY_REQUESTED_WEB_USER_ACCESS, REQUEST_NEW_PIN, GET_RECORD_HAS_ACTIVE_PIN } from '../../requests'
import { Checkbox } from "components/Wizard2/fieldComponents/Form";

const OWNERSHIP_REQUEST_DESCRIPTION = process.env.OWNERSHIP_REQUEST_DESCRIPTION;
const OWNERSHIP_REQUEST_ATTESTATIONS = process.env.OWNERSHIP_REQUEST_ATTESTATIONS;
const REQUEST_PIN_EVEN_WITH_OWNERSHIP = process.env.REQUEST_PIN_EVEN_WITH_OWNERSHIP;
const OWNERSHIP_REQUEST_SUCCESSFUL_MESSAGE = process.env.OWNERSHIP_REQUEST_SUCCESSFUL_MESSAGE;
const HIDE_REQUIRED_PIN_ATTESTATION_MESSAGE = process.env.HIDE_REQUIRED_PIN_ATTESTATION_MESSAGE;
const HIDE_ICON_CIRCLE_CHECK = process.env.HIDE_ICON_CIRCLE_CHECK;
const EXISTING_PIN_REQUEST_FOR_AUTH_USER_MESSAGE = process.env.EXISTING_PIN_REQUEST_FOR_AUTH_USER_MESSAGE;

export default class RequestOwnership extends Component{
  constructor(){
    super()
    this.state = {
      requestSuccessful: null,
      hasRequested: null,
      attestation1Checked: false,
      pinRequestSuccessful: null,
      error: null,
      recordHasActivePin: null
    }
  }
  componentDidMount = () => {
    GET_USER_HAS_ALREADY_REQUESTED_WEB_USER_ACCESS(this.props.category, this.props.source_id, hasRequested => {
      this.setState({hasRequested})
    });
    this.getNumActivePins();
  }
  getNumActivePins = () => {
    GET_RECORD_HAS_ACTIVE_PIN(
      this.props.category,
      this.props.source_id,
      recordHasActivePin => {
        this.setState({ recordHasActivePin });
      }
    );
  };
  setValue = (name, checked) => {
    this.setState({ [name]: checked });
  };
  requestAccess = () => {
    REQUEST_RECORD_ACCESS(this.props.category, this.props.source_id, successful => {
      if(successful){
        this.setState({requestSuccessful: true})
        // window.setTimeout(this.props.onRequestModalClose, 3000)
      }else{
        this.setState({requestSuccessful: false})
      }
    })
  }
  requestPin = () => {
    REQUEST_NEW_PIN(
      this.props.category,
      this.props.source_id,
      success => {
        this.setState({ pinRequestSuccessful: success });
        this.getNumActivePins();        
      },
      err => {
        this.setState({
          error:
            "Something went wrong. Please try again later, and if the problem persists please contact customer support."
        });
      }
    );
  };
  render(){
    return(
      <div className='request-ownership'>
        {REQUEST_PIN_EVEN_WITH_OWNERSHIP && (this.state.pinRequestSuccessful || this.state.recordHasActivePin) &&
        <div className='row'>
          <div className='col-12'>
            <p className='center-text'>
              PIN has been requested. A PIN letter will be sent to the record's mailing address on file. Follow the instructions provided in the letter to enter the PIN and obtain access to this record.
            </p>
          </div>
        </div>
        }
        {
          //b-63093
          //adding the CA condition since in CA, we might still have an active PIN even with an active onwer.
          this.state.requestSuccessful !== true && this.state.hasRequested === false && this.state.pinRequestSuccessful !== true && (process.env.STATE_ABBR === "CA" || this.state.recordHasActivePin !== true) &&
          <div>
            <div className='row'>
              <div className='col-12'>
                <p className='center-text'>
                  {
                    OWNERSHIP_REQUEST_DESCRIPTION ?
                    <ReactMarkdown source={OWNERSHIP_REQUEST_DESCRIPTION} className="markdown" />
                    :
                    <span>To become an owner of this record, a current owner will need to grant you access. To request access, click <strong>Request Access</strong> below.</span>
                  }
                </p>
              </div>
            </div>
            {OWNERSHIP_REQUEST_ATTESTATIONS && (
              <div className="wizard">
                <div className="row margin-top">
                  <div className="col-12">
                  {!HIDE_REQUIRED_PIN_ATTESTATION_MESSAGE && (
                    <p className="attestation-hint">You <strong>must</strong> check the box below to proceed</p>
                  )}
                  </div>
                </div>
                
                <div className="row">
                  <div className="col-12 checkbox-column">
                    <Checkbox
                      fieldId="attestation1"
                      value={this.state.attestation1Checked}
                      onChange={checked => {
                        this.setValue("attestation1Checked", checked);
                      }}
                      label="I certify that I am authorized to request and obtain access to this record."
                    />
                  </div>
                </div>
              </div>
            )}
            {REQUEST_PIN_EVEN_WITH_OWNERSHIP && (
            <div className='row margin-top'>
              <div className='col-12 button-column'>
                <DialogButton label='Request PIN' disabled={!(!OWNERSHIP_REQUEST_ATTESTATIONS || this.state.attestation1Checked)} className='btn-raised' customClickHandler onClick={this.requestPin} />
              </div>
            </div>)}
            <div className='row margin-top'>
              <div className='col-12 button-column'>
                <DialogButton label={REQUEST_PIN_EVEN_WITH_OWNERSHIP ? 'Request Access from Current Authorized User' : 'Request Access'} disabled={!(!OWNERSHIP_REQUEST_ATTESTATIONS || this.state.attestation1Checked)} className='btn-raised' customClickHandler onClick={this.requestAccess} />
              </div>
            </div>
            {
              this.state.requestSuccessful === false &&
              <div className='row margin-top'>
                <div className='col-12 button-column'>
                  <p className='error'>
                    Something went wrong while trying to request access. Try again later.
                  </p>
                </div>
              </div>
            }
          </div>
        }
        {
          this.state.hasRequested === null &&
          <div className='loader-wrapper'>
            <Spinner themeColor='medium-neutral' size='small' />
          </div>
        }
        {
          this.state.hasRequested === true && !REQUEST_PIN_EVEN_WITH_OWNERSHIP &&
          <div className='row'>
            <div className='col-12'>
              <p className='center-text'>
                You've already requested access to this record.
              </p>
            </div>
          </div>
        }
        {
          this.state.hasRequested === true && REQUEST_PIN_EVEN_WITH_OWNERSHIP && !this.state.recordHasActivePin &&
          <div>
            <div className='row'>
              <div className='col-12'>
                <p className='center-text'>
                  {
                    EXISTING_PIN_REQUEST_FOR_AUTH_USER_MESSAGE || "Access from a current authorized user has already been requested. If the request for access has not been accepted, a PIN may be requested."
                  }
                  
                </p>
              </div>
            </div>
            {OWNERSHIP_REQUEST_ATTESTATIONS && (
            <div>
              <div className="wizard">
                <div className="row margin-top">
                  <div className="col-12 checkbox-column">
                    <Checkbox
                      fieldId="attestation1"
                      value={this.state.attestation1Checked}
                      onChange={checked => {
                        this.setValue("attestation1Checked", checked);
                      }}
                      label="I certify that I am authorized to request and obtain access to this record."
                    />
                  </div>
                </div>
              </div>
              <div className='row margin-top'>
                <div className='col-12 button-column'>
                  <DialogButton label='Request PIN' disabled={!(!OWNERSHIP_REQUEST_ATTESTATIONS || this.state.attestation1Checked)} className='btn-raised' customClickHandler onClick={this.requestPin} />
                </div>
              </div>              
            </div>          
            )}
          </div>
        }
        {
          this.state.requestSuccessful === true && OWNERSHIP_REQUEST_SUCCESSFUL_MESSAGE &&
          <div className='row'>
            <div className='col-12'>
              <p className='center-text'>
              <span className={HIDE_ICON_CIRCLE_CHECK ? "" : "icon icon-circle-check"}/><ReactMarkdown source={OWNERSHIP_REQUEST_SUCCESSFUL_MESSAGE} className="markdown" />
              </p>
            </div>
          </div>
        }
        {
          this.state.requestSuccessful === true && !OWNERSHIP_REQUEST_SUCCESSFUL_MESSAGE &&
          <div className='row'>
            <div className='col-12'>
              <p className='center-text error success'>
              <span className={HIDE_ICON_CIRCLE_CHECK ? "" : "icon icon-circle-check"}/>You've successfully requested access to this record.
              </p>
            </div>
          </div>
        }
        {this.state.error && <p className="error">{this.state.error}</p>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/MyRecords/RequestOwnership.js